import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { userInfoAtom } from '~atoms';
import { SkcUserGroupsOverviewContainer } from '~features/access';

import Page from '../page';

const SkcUserGroupsPage = () => {
	const { t } = useTranslation();

	const [userInfo] = useAtom(userInfoAtom);

	return (
		<Page title={t('accessGroups')}>
			<SkcUserGroupsOverviewContainer />
		</Page>
	);
};

export default SkcUserGroupsPage;
